import {
    Component, OnInit, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef
} from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'app/services/data.service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ProjectManagementService } from 'app/services/project-management.service';
import { Transition } from '@uirouter/angular';
import { FrontEndService } from "app/services/front-end.service";
import { LogService } from "app/services/log.service";
import { StateService } from '@uirouter/angular';
import * as moment from 'moment';
import { Moment } from "moment";
import { MultipleDatePickerComponent } from "../multiple-date-picker-angular/dist/multiple-date-picker.component";

@Component({
    selector: 'app-edit-project',
    templateUrl: './edit-project.component.html',
    styleUrls: ['./edit-project.component.scss']
})

export class EditProjectComponent implements OnInit {

    @ViewChild('cutoff_date_view') cutoff_date_view: MultipleDatePickerComponent;
    @ViewChild('content') content: ElementRef;

    title = "";
    subject_patent = "";
    required_delivery_date = "";
    delivery_date = [];
    technical_field = "";
    interim_date_string = "";
    interim_date = [];
    claims_to_be_searched = "";
    prior_art_cut_off_date = [];
    prior_art_cut_off_date_display = [];
    project_description = "";
    other_information = "";
    useful_information = "";
    users_data: any;
    patent_number_error = false;
    subject_patent_error = false;
    project_description_error = false;
    other_information_error = false;
    technical_field_error = false;
    delivery_date_error = false;
    interim_date_error = false;
    claims_to_be_searched_error = false;
    cutoff_date_error = false;
    prior_art_cut_off_date_error = false;
    patent_engineer_error = false;
    technical_expert_error = false;
    researcher_error = false;
    reviewer_error = false;
    legal_council_error = false;
    project_status_error = false;
    useful_information_error = false;
    legal_counsel_error = false;
    errorMessage = "";
    project_status = "";
    patent_engineer = [];
    researcher = [];
    legal_counsel = [];
    technical_expert = [];
    reviewer = [];
    known_prior_art = "";
    known_prior_art_error = false;
    project_type_error = false;
    cutoff_date = [];
    showCutOffDatePicker = true;
    project_is_active: boolean;
    fullScreenLoader = false;
    patent_engineer_and_technicalExpert: any;
    researcher_and_reviewer: any;
    showDeliveryDatePicker = true;
    showInterimDatePicker = true;
    assignees_for_legal_counsel_and_IPR;
    assignees_for_researcher_and_reviewer;
    projectType = "";
    fieldNames = {};
    usersFetched = false;
    projectDetailsFetched = false;
    sep = false;
    sso = false;
    usIpr = false;
    closeResult: string;
    public modalRef: NgbModalRef;
    clickType = '';

    // On error, Focus variables
    public claims_to_be_searched_focus = new EventEmitter<boolean>();
    public required_delivery_date_focus = new EventEmitter<boolean>();
    public patent_number_focus = new EventEmitter<boolean>();
    public project_type_focus = new EventEmitter<boolean>();

    constructor(
        private user_management_service: UserManagementService,
        private modalService: NgbModal,
        public data_service: DataService,
        private _location: Location,
        private translate: TranslateService,
        public front_end_service: FrontEndService,
        private project_management_service: ProjectManagementService,
        private transition: Transition,
        private stateService: StateService,
        private logService: LogService,
        private cdr: ChangeDetectorRef
    ) {
    }

    checkSelection() {
        this.prior_art_cut_off_date = [];
        this.prior_art_cut_off_date_display = [];
        for (let i = 0; i < this.cutoff_date.length; i++) {
            this.logService.printLog("Selected dates = " + this.cutoff_date[i]);
            // to send with 2017-09-01 format
            const selectedDate = this.data_service.getFormattedDate(this.cutoff_date[i]);
            this.prior_art_cut_off_date.push(selectedDate);
            // to display with 01-sep-2017 format
            const selectedDateToDisplay = this.data_service.getFormattedDate(this.cutoff_date[i])
            this.prior_art_cut_off_date_display.push(selectedDateToDisplay);
        }

        this.logService.printLog("Cut off date edited" + this.prior_art_cut_off_date_display);
    }

    cutOffDateEdited() {
        this.cutoff_date = [];
        for (let i = 0; i < this.prior_art_cut_off_date_display.length; i++) {
            this.logService.printLog("Cut off date - " + this.cutoff_date[i]);
            this.cutoff_date.push(moment(moment(this.prior_art_cut_off_date_display[i]).format("YYYY-MM-DDT") + "00:00Z"));
        }

        this.checkSelection();
        setTimeout(() => {
            this.cutoff_date_view.generate();
        }, 200);
    }

    singleDateSelection(event, date) {
        // Empty function needed to enable day selection
    }

    checkSelectionDelivery() {
        if (this.delivery_date[0]) {
            this.required_delivery_date = moment(this.delivery_date[0]._d).format("MMM DD, YYYY");
        } else {
            this.required_delivery_date = "";
        }
    }

    checkSelectionInterim() {
        if (this.interim_date[0]) {
            this.interim_date_string = moment(this.interim_date[0]._d).format("MMM DD, YYYY");
        } else {
            this.interim_date_string = "";
        }
    }

    ngOnInit() {
        this.cutoff_date = [];
        this.fetchUsers();

        if (this.transition.params().project_id !== "" && this.transition.params().project_id !== undefined) {
            if (this.data_service.selected_project !== +this.transition.params().project_id) {
                this.data_service.selected_project = +this.transition.params().project_id;
            }
            this.get_project_details(this.data_service.selected_project);
        } else {
            this.stateService.go("Forbidden");
        }
    }

    setUser(userId) {
        this.fetchUsers(userId);
    }

    fetchUsers(userId = null) {
        this.fullScreenLoader = true;
        this.usersFetched = false;
        this.user_management_service.userList((resp) => {
            this.users_data = resp.data;
            const inputTag = [];
            const setUser = [];
            // var temp = [];
            for (let i = 0; i < this.users_data.length; i++) {
                const obj1 = {};
                obj1['role'] = this.users_data[i]['role'];
                obj1['value'] = JSON.stringify(resp.data[i]['id']);
                obj1['display'] = resp.data[i].name + '(' + resp.data[i].username + ')';

                if (this.users_data[i]['is_active']) {
                    inputTag.push(obj1);
                }

                if (userId != null) {
                    if (this.users_data[i]['id'] === userId) {
                        const obj2 = new Object();
                        obj2['role'] = this.users_data[i]['role'].toString();
                        obj2['id'] = this.users_data[i]['id'].toString();
                        obj2['name'] = this.users_data[i].name;
                        obj2['username'] = this.users_data[i].username;
                        setUser[0] = obj2;

                        if (this.clickType === "patent_engineer" && obj2["role"] === "3") {
                            this.patent_engineer.push(this.get_existing_users(setUser)[0]);
                        }
                        if (this.clickType === "technical_expert" && obj2["role"] === "3") {
                            this.technical_expert.push(this.get_existing_users(setUser)[0]);
                        }
                        if (this.clickType === "legal_counsel" && obj2["role"] === "3") {
                            this.legal_counsel.push(this.get_existing_users(setUser)[0]);
                        }
                        if (this.clickType === "reviewer" && obj2["role"] === "2") {
                            this.reviewer.push(this.get_existing_users(setUser)[0]);
                        }
                        if (this.clickType === "researcher" && obj2["role"] === "2") {
                            this.researcher.push(this.get_existing_users(setUser)[0]);
                        }
                    }
                }
            }

            this.patent_engineer_and_technicalExpert = this.data_service.filter_on_role_type(inputTag, '3');
            this.researcher_and_reviewer = this.data_service.filter_on_role_type(inputTag, '2');
            const assignees_for_admin = this.data_service.filter_on_role_type(inputTag, '1');
            const filter_by_user_type_customer_admin = this.data_service.filter_on_role_type(inputTag, '4');
            this.assignees_for_legal_counsel_and_IPR = this.patent_engineer_and_technicalExpert.concat(filter_by_user_type_customer_admin);
            this.assignees_for_researcher_and_reviewer = this.researcher_and_reviewer.concat(assignees_for_admin);
            this.usersFetched = true;
            this.hideLoader();
        });
    }

    get_project_details(project_id) {
        this.fullScreenLoader = true;
        this.projectDetailsFetched = false;
        this.project_management_service.get_project_details(project_id, (resp) => {
            if (resp.status === true) {
                this.fill_form_from_data(resp.data);

                if (
                    +this.data_service.currentUser['role'] !== 1 &&
                    +this.data_service.currentUser['role'] !== 0 &&
                    resp.data['owner']['id'] !== this.data_service.currentUser['id'] &&
                    +this.data_service.currentUser['role'] !== 4
                ) {
                    this.stateService.go("Forbidden");
                }

            } else {
                this.logService.printLog("Failed Project Details controller callback");
            }
            this.projectDetailsFetched = true;
            this.hideLoader();

        });
    }

    onSubmit(projectDetails) {
        this.logService.printLog("Project details", projectDetails);
        if (projectDetails.project_type === null || projectDetails.project_type.trim() === "" || projectDetails.project_type.trim() === 'null') {
            this.hideAllErrors();
            this.project_type_focus.emit(true);
            this.project_type_error = true;
            this.errorMessage = 'select_project_type';
        } else if (projectDetails.title.trim() === "" || projectDetails.title === undefined) {
            this.patent_number_error = true;
            this.errorMessage = 'please_enter_a_patent_number';
            this.patent_number_focus.emit(true);
        } else if (this.required_delivery_date === "") {
            this.hideAllErrors();
            this.required_delivery_date_focus.emit(true);
            this.delivery_date_error = true;
            this.errorMessage = 'please_select_a_delivery_date';
        } else if (projectDetails.claims_to_be_searched.trim() === "" || projectDetails.claims_to_be_searched === undefined) {
            this.hideAllErrors();
            this.claims_to_be_searched_focus.emit(true);
            this.claims_to_be_searched_error = true;
            this.errorMessage = 'please_enter_claim_search';
        } else {
            this.hideAllErrors();

            projectDetails['required_delivery_date'] = moment(this.delivery_date[0]._d).format("YYYY-MM-DDT") + "00:00Z";
            if (this.interim_date_string !== "") {
                projectDetails['interim_date'] = moment(this.interim_date[0]._d).format("YYYY-MM-DDT") + "00:00Z";
            }
            projectDetails['patent_engineer'] = this.convertStringArrayToInt(this.arrayFromJson(this.patent_engineer));
            projectDetails['technical_expert'] = this.convertStringArrayToInt(this.arrayFromJson(this.technical_expert));
            projectDetails['researcher'] = this.convertStringArrayToInt(this.arrayFromJson(this.researcher));
            projectDetails['reviewer'] = this.convertStringArrayToInt(this.arrayFromJson(this.reviewer));
            projectDetails['legal_counsel'] = this.convertStringArrayToInt(this.arrayFromJson(this.legal_counsel));

            projectDetails['status'] = this.project_status;

            const cutOffDates = [];
            for (let i = 0; i < this.cutoff_date.length; i++) {
                this.logService.printLog("Cut off date - " + this.cutoff_date[i]);
                cutOffDates.push({
                    "this_date": moment(this.cutoff_date[i]._d).format("YYYY-MM-DDT") + "00:00Z"
                });
            }
            projectDetails['prior_art_cut_off_date'] = cutOffDates;
            projectDetails['subject_patent'] = projectDetails.useful_information;

            if (!projectDetails['required_delivery_date']) {
                delete projectDetails.required_delivery_date;
            }

            if (!projectDetails['interim_date']) {
                delete projectDetails.interim_date;
            }

            delete projectDetails.useful_information;
            delete projectDetails.multi_date;
            delete projectDetails.project_status;

            this.fullScreenLoader = true;
            this.project_management_service.edit_project(projectDetails, this.data_service.selected_project, (resp) => {
                // this.fill_form_from_data();
                this.fullScreenLoader = false;
                if (resp.status === true) {
                    this.front_end_service.addToast(
                        "Success",
                        "project_details_changed",
                        "success"
                    );

                    this.front_end_service.back();
                }
            });
        }
    }

    unformat_date(dateString) {
        let returnDate: Moment = null;

        if (dateString) {
            returnDate = moment(dateString);
        }

        return returnDate;
    }

    cutoff_date_format(date_array) {
        const temp_dates = [];
        for (let i = 0; i < date_array.length; i++) {
            temp_dates.push(moment(date_array[i]["this_date"]));
        }
        return temp_dates;
    }

    arrayFromJson(arrayJson) {
        const newarray = [];
        for (let i = 0; i < arrayJson.length; i++) {
            newarray[i] = arrayJson[i].value
        }
        return newarray;
    }

    convertStringArrayToInt(stringArray) {
        const intArray = [];
        for (let i = 0; i < stringArray.length; i++) {
            intArray.push(+stringArray[i]);
        }
        return intArray;
    }

    get_existing_users(users) {
        const temp_users = [];
        for (let i = 0; i < users.length; i++) {
            const obj1 = {};
            obj1['value'] = users[i]['id'].toString();
            obj1['display'] = users[i].name + '(' + users[i].username + ')';
            temp_users.push(obj1);
        }
        return temp_users;
    }

    onSelectionProjectStatus(x) {
        this.project_status = x.value
    }

    deleteProject($event) {
        this.front_end_service.confirmAlert("confirm", this.project_is_active ? 'delete_project_confirmation' : 'recover_project_confirmation', 'warning', (result) => {
            if (result.value) {
                this.fullScreenLoader = true;
                this.project_management_service.delete_project(this.data_service.selected_project, (resp) => {
                    this.fullScreenLoader = false;
                    if (resp.status) {
                        this.logService.printLog("Project Deleted");
                        this.project_is_active = !this.project_is_active;

                        let message = "project_deleted_successfully";
                        if (this.project_is_active) {
                            message = "project_recovered_successfully";
                        }
                        this.front_end_service.addToast(
                            "Success",
                            message,
                            "success"
                        );

                        this.stateService.go('home');
                    } else {
                        this.logService.printLog("Failed Project Details controller callback");
                    }
                });
            }
        })
    }

    hideAllErrors() {
        this.project_status_error = false;
        this.reviewer_error = false;
        this.researcher_error = false;
        this.technical_expert_error = false;
        this.project_description_error = false;
        this.other_information_error = false;
        this.patent_engineer_error = false;
        this.legal_council_error = false;
        this.interim_date_error = false;
        this.prior_art_cut_off_date_error = false;
        this.cutoff_date_error = false;
        this.claims_to_be_searched_error = false;
        this.delivery_date_error = false;
        this.technical_field_error = false;
        this.subject_patent_error = false;
        this.patent_number_error = false;
        this.known_prior_art_error = false;
        this.project_type_error = false;
    }

    fill_form_from_data(project_edited) {
        this.title = project_edited.title;
        this.subject_patent = project_edited.subject_patent;
        this.projectType = project_edited['project_type'];

        this.sep = project_edited['is_standard_related'];
        this.sso = project_edited['is_sso_needed'];
        this.usIpr = project_edited['is_us_ipr_special'];

        if (project_edited.required_delivery_date) {
            const deliveryDate: Moment = this.unformat_date(project_edited.required_delivery_date);
            if (deliveryDate !== null) {

                this.delivery_date = [deliveryDate];
                this.required_delivery_date = deliveryDate.format("MMM DD, YYYY");
            }
        }

        if (project_edited.interim_date) {
            const interimDate: Moment = this.unformat_date(project_edited.interim_date);
            if (interimDate !== null) {
                this.interim_date = [interimDate];
                this.interim_date_string = interimDate.format("MMM DD, YYYY");
            }
        }

        this.technical_field = project_edited.technical_field;

        if (project_edited.claims_to_be_searched) {
            this.claims_to_be_searched = project_edited.claims_to_be_searched;
        }

        // cutoff data will automatically set prior art date.
        this.logService.printLog("Dates received - " + project_edited.prior_art_cut_off_date);
        this.cutoff_date = this.cutoff_date_format(project_edited.prior_art_cut_off_date);
        this.checkSelection();

        this.project_description = project_edited.project_description;
        this.other_information = project_edited.other_information;
        this.useful_information = project_edited.subject_patent;
        this.errorMessage = project_edited.errorMessage;

        // this function will set project status in UI.
        this.onSelectionProjectStatus({ "value": project_edited.status });

        this.project_is_active = project_edited.isActive;

        this.patent_engineer = this.get_existing_users(project_edited.patent_engineer);
        this.researcher = this.get_existing_users(project_edited.researcher);
        this.technical_expert = this.get_existing_users(project_edited.technical_expert);
        this.reviewer = this.get_existing_users(project_edited.reviewer);
        this.legal_counsel = this.get_existing_users(project_edited.legal_counsel);

        this.known_prior_art = project_edited.known_prior_art;
    }

    open(content, type) {
        this.clickType = type;
        this.modalRef = this.modalService.open(content, { size: 'lg' });
        this.modalRef.result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    closeModal() {
        this.modalRef.close();
        this.fetchUsers();
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    projectTypeChanged(event) {
        this.projectType = event.value;
        this.fieldNames = this.data_service.getFieldNamesBasedOnProjectType(this.projectType);
        this.cdr.detectChanges();
    }

    hideLoader() {
        if (this.usersFetched && this.projectDetailsFetched) {
            this.fullScreenLoader = false;
        }
    }
}
